import React from 'react';
import { Link } from 'react-router-dom'; 
import heroImage from '../assets/qf_hero_1129.png'; 
import appStoreBtn from '../assets/App-Store-Download.png';
import bagLogo from '../assets/baglogo.png'; /* <-- Imported the bag logo */
import '../style.css';

const Hero = () => {
  return (
    <section className="hero-container">
      {/* LEFT COLUMN: Text Content */}
      <div className="hero-content">
        
        {/* New Bag Logo Element */}
        <img 
          src={bagLogo} 
          alt="QuickFit Bag Logo" 
          className="hero-bag-logo" 
        />

        <h1>
          YOUR FASHION,<br />
          DELIVERED TODAY
        </h1>
        <p>
          Skip the wait and get the latest styles instantly. Browse our curated collections,
          order from your phone, and have it in your hands today.
        </p>

        {/* Keeping Shop Now button for later webapp version 
        <Link to="/signup" className="shop-btn">
          SHOP NOW
        </Link>
        */}

        {/* App Store Download Button */}
        <div className="hero-download">
          <a 
            href="https://apps.apple.com/us/app/quickfit-inc/id6745117626" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-store-link"
          >
            <img 
              src={appStoreBtn} 
              alt="Download on the App Store" 
              className="app-store-img"
            />
          </a>
        </div>

      </div>

      {/* RIGHT COLUMN: Image */}
      <div className="hero-image-wrapper">
        <img src={heroImage} alt="Fashion models on street" />
      </div>
    </section>
  );
};

export default Hero;